import { Component, OnInit, OnDestroy } from '@angular/core';

import { AdminService, ProjectService, ProfileService } from '../../_services';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tab-list',
  templateUrl: './tab-list.component.html',
  styleUrls: ['./tab-list.component.scss']
})
export class TabListComponent implements OnInit {
  tabs:any[];
  id: string;
  private subscription:Subscription;
  constructor(
    private _admin : AdminService,
    private _profile: ProfileService,
    private _toastr: ToastrService
  ) { }

  ngOnInit() {
    // debugger;
    this.fetchUserTabs();
  }

  

  fetchUserTabs(){
    this._profile.currentTab.subscribe(id=>{
      this.id = id;
    })
    
    this.subscription = this._admin.getUserTabs(localStorage.getItem('uid')).subscribe(resp=>{
      this.tabs = [];
      for (let item of resp) {
        this.tabs.push(item.payload.doc.data());
      }
      
    },err=>{
      this._toastr.error(`Error occurred while loading tab data. Please try again by logging out then login back in.`,"",{ timeOut: 4000 });
    })
  }  


  deleteTab(id){
    this._admin.deleteTab(id).then(res=>{
      this._toastr.success(`Tab deleted successfully!`,"",{ timeOut: 4000 });
    },err=>{
      this._toastr.error(err.error ? err.error : `Something went wrong!`,"",{ timeOut: 4000 });
    })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }

}
